import * as tokens from "@galaxy-ds/tokens/dist/leap/web/cjs/tokens";

const grey = {
  900: "#1c2836",
  800: "#263042",
  700: "#444444",
  600: "#889099",
  500: "#7a7a7a",
  400: "#d6d6d6",
  300: "#d8d8d8",
  200: "#f3f3f3",
  100: "#eeeeee",
  50: "#FFFFFF",
};

const blue = {
  400: "#EBF2F9",
  300: "#ebf1f4",
  200: "#C2D8E7",
  100: "#e4edf5",
  50: "#E0ECF5",
};

const extendedPalette = {
  border: {
    main: tokens.ColorTextPrimary,
    // light: tokens.ColorBorderLight,
    // dark: tokens.ColorBorderDark,
    // darker: tokens.ColorBorderDarker,
  },
};

const palette = {
  primary: {
    main: tokens.ColorPrimaryMain,
    light: tokens.ColorPrimaryLight,
    dark: tokens.ColorPrimaryDark,
    transparent: "rgba(0,96,172, 0.12)",
    contrastText: "#fff",
  },
  secondary: {
    main: tokens.ColorSecondaryMain,
    light: tokens.ColorSecondaryLight,
    dark: tokens.ColorSecondaryDark,
    transparent: "rgba(245,146,69, 0.12)",
    contrastText: "#fff",
  },
  default: {
    main: "#6e7781",
    light: "#EFF0F0",
    dark: "#5c646c",
    transparent: "rgba(30,54,94, 0.15)",
    contrastText: "#fff",
  },
  info: {
    main: tokens.ColorContextualInfoLight,
    light: tokens.ColorContextualInfodLight,
    dark: tokens.ColorContextualInfoDark,
    transparent: "rgba(30,54,94, 0.15)",
    contrastText: "#fff",
  },
  error: {
    main: tokens.ColorContextualDangerMain,
    light: tokens.ColorContextualDangerLight,
    dark: tokens.ColorContextualDangerDark,
    transparent: "rgba(192,46,33, 0.12)",
  },
  warning: {
    main: tokens.ColorContextualWarningMain,
    light: tokens.ColorContextualWarningLight,
    dark: tokens.ColorContextualWarningDark,
    transparent: "rgba(245,146,69, 0.12)",
  },
  success: {
    main: tokens.ColorContextualSuccessMain,
    light: tokens.ColorContextualSuccessLight,
    dark: tokens.ColorContextualSuccessDark,
    transparent: "rgba(63,175,42, 0.12)",
  },
  text: {
    primary: tokens.ColorTextPrimary,
    secondary: tokens.ColorTextSecondary,
    disabled: tokens.ColorTextDisabled,
    link: "#0060AA",
    active: "#1E365E",
    light: "#AAB0B8",
  },
  background: {
    paper: "#ffffff",
    default: "#eeeeee",
    light: "rgb(249, 249, 249)",
    footer: "#ffffff",
  },
  action: {
    hover: blue[200],
  },
  divider: "#d8d8d8",
  grey: {
    ...grey,
  },
  blue: {
    ...blue,
  },
  ...extendedPalette,
};

const palettes = {
  palette,
  extendedPalette,
  grey,
  blue,
};

export default palettes;
